import { Routes } from '@angular/router';

import { provideServiceManagementFeature } from './service-management.module';

export const SERVICE_MANAGEMENT_ROUTES: Routes = [
  {
    path: 'service-management/create',
    providers: [provideServiceManagementFeature()],
    loadComponent: () => import('./pages/service-form/service-form').then((m) => m.ServiceForm),
    data: {
      layout: {
        activeItem: 'Service Management',
        breadcrumb: 'Service Management > Create Service',
        title: 'Create Service',
        subtitle: 'Add a new service to your platform offerings',
        showToolbar: false,
        backTo: '/service-management',
      },
    },
  },
  {
    path: 'service-management/:serviceId/edit',
    providers: [provideServiceManagementFeature()],
    loadComponent: () => import('./pages/service-form/service-form').then((m) => m.ServiceForm),
    data: {
      layout: {
        activeItem: 'Service Management',
        breadcrumb: 'Service Management > Edit Service',
        title: 'Edit Service',
        subtitle: 'View service details & offerings',
        showToolbar: false,
        backTo: '/service-management',
      },
    },
  },
  {
    path: 'service-management/:serviceId',
    providers: [provideServiceManagementFeature()],
    loadComponent: () =>
      import('./pages/service-detail/service-detail').then((m) => m.ServiceDetail),
    data: {
      layout: {
        activeItem: 'Service Management',
        breadcrumb: 'Service Management > View Service',
        title: 'View Service',
        subtitle: 'View service details and checklist',
        showToolbar: false,
        backTo: '/service-management',
      },
    },
  },
  {
    path: 'service-management',
    providers: [provideServiceManagementFeature()],
    loadComponent: () =>
      import('./pages/service-management-list/service-management-list').then(
        (m) => m.ServiceManagementList,
      ),
    data: {
      layout: {
        activeItem: 'Service Management',
        breadcrumb: 'List of Services',
        title: 'Service Management',
        subtitle: 'Manage all available services and their configurations',
        searchPlaceholder: 'Search by service name...',
        showFilter: true,
        showMobileFilterOnly: true,
      },
    },
  },
];
